import CatalogService from '@utility/services/catalog';
import { buildMappedItemsParams } from '../lib/mappable-params';
import { catalogMappingKeys } from '../lib/query-keys';
import { useMappablePage } from './use-mappable-listings';

/* M2: a page of products with their mapped listings, the Mapped tab's Products view. */
export function useMappedItems() {
  return useMappablePage(
    buildMappedItemsParams,
    catalogMappingKeys.mappedItems,
    CatalogService.getMappedItems,
  );
}
